import { useGetAllImporters } from '@/features/importers/hooks/importers'
import { ListboxGroup, Alert, PageSection } from '@/common'
import useI18n from '@/shared/hooks/usei18n'
import { ImportedGoodFormData } from './ImportedGoodForm.schema'
import { Link } from 'react-router-dom'
import { Trans } from 'react-i18next'

export default function ImportedGoodImporterSelectForm({
  organizationId,
  data,
  onChange
}: {
  organizationId: string
  data: ImportedGoodFormData
  onChange: (data: ImportedGoodFormData) => void
}) {
  const { t } = useI18n()

  const importersQuery = useGetAllImporters(organizationId)
  const importers = importersQuery.data ?? []

  const importerOptions = importers.map(importer => ({
    value: importer.id,
    label: importer.name
  }))

  return (
    <PageSection
      title={t('cbamReporting:cbamReportDetails.importedGoodCreateDialog.sections.importer')}
    >
      {importers.length === 0 && (
        <Alert type="warning">
          <Trans
            i18nKey="cbamReporting:cbamReportDetails.importedGoodCreateDialog.noImportersWarning"
            components={{
              Link: <Link className="text-blue-500 underline" to="/importers" />
            }}
          />
        </Alert>
      )}
      <ListboxGroup
        disabled={importers.length === 0}
        label={t('cbamReporting:cbamReportDetails.importedGoodCreateDialog.fields.importer')}
        value={data.importerId ?? ''}
        onChange={value => onChange({ ...data, importerId: value ? value : undefined })}
        options={importerOptions}
      />
    </PageSection>
  )
}
